import { render, staticRenderFns } from "./ProductsCatalog.vue?vue&type=template&id=3cc8a0e7"
import script from "./ProductsCatalog.vue?vue&type=script&lang=js"
export * from "./ProductsCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports